export const text = {
  subscriptionName: "Subscription Name",
  subscriptionAmount: "Subscription Amount",
  subscriptionNamePlaceholder: "Enter Name",
  subscriptionAmountPlaceholder: "Enter Amount",
  packageName: "Package Name",
  packageNamePlaceholder: "Enter Package Name",
  storageLabel: "storage",
  packagePriceLabel: "Package Price",
  storagePlaceholder: "Enter Storage",
  packagePricePlaceholder: "Enter Package Price",
};
